export enum MediaTab {
  VIDEO = 'VIDEO', // 미디어
  CAMPAIGN = 'CAMPAIGN', // 방송
}

export enum MediaViewMode {
  CARD = 'CARD', // 카드뷰
  LIST = 'LIST', // 리스트뷰
}
